import { CustomStep } from "../warehouseJoyrideSteps";

const getVW = () => window.visualViewport?.width ?? window.innerWidth;

export const pickHeadroom = (step: CustomStep): { top: number; bottom: number } => {
    const vw = getVW();

    if (step.headroomRules?.length) {
        const rule = step.headroomRules.find((r) => {
            const okMin = r.minW == null || vw >= r.minW;
            const okMax = r.maxW == null || vw <= r.maxW;
            return okMin && okMax;
        });
        if (rule) {
            return {
                top: Number(rule.top ?? 0),
                bottom: Number(rule.bottom ?? 0),
            };
        }
    }
    return {
        top: Number(step.topHeadroom ?? 0),
        bottom: Number(step.bottomHeadroom ?? 0),
    };
};
